package com.rainbowclubs.rainbow.domain.use_cases.events

import com.rainbowclubs.rainbow.data.models.EventsPageResponse
import com.rainbowclubs.rainbow.domain.repositories.EventsRepository

class GetClubEventsUseCase(
    private val eventsRepository: EventsRepository,
) {
    suspend operator fun invoke(
        clubId: String,
        page: Int = 1,
        limit: Int = 20,
    ): Result<EventsPageResponse> {
        return eventsRepository.getClubEvents(
            clubId = clubId,
            page = page,
            limit = limit,
        )
    }
}
